<template>
  <div class="container">
    <h1 class="title">Angebote</h1>
    <h2 class="subtitle">Übersicht über die verfügbaren Angebote</h2>
    <!-- <div class="content">
      <p class="buttons is-pulled-right">
        <b-button type="is-dark" icon-left="sync" @click="refreshData">
          Refresh
        </b-button>
      </p>
    </div> -->
    <div class="columns">
      <div class="column">
        <b-field>
          <b-radio-button
            v-model="filterMod"
            @input="search"
            native-value="Offline"
            type="is-danger"
          >
            <b-icon icon="times"></b-icon>
            <span>Offline</span>
          </b-radio-button>

          <b-radio-button
            v-model="filterMod"
            @input="search"
            native-value="Online"
            type="is-success"
          >
            <b-icon icon="check"></b-icon>
            <span>Online</span>
          </b-radio-button>

          <b-radio-button
            v-model="filterMod"
            @input="search"
            native-value="Default"
          >
            Beides
          </b-radio-button>
        </b-field>
      </div>
      <div class="column">
        <b-field>
          <b-input
            placeholder="Suche..."
            icon="search"
            v-model="freetext"
            @keyup.enter.native="search"
          >
          </b-input>
        </b-field>
      </div>
    </div>

    <OffersTable
      :results="offers"
      @request-page="pageChange"
      @request-sort="pageSort"
      :pageSize="pageSize"
      :page="page"
      :total="total"
      :sortOrder="sortOrder"
      :sortField="sortField"
    />
  </div>
</template>
<script>
import OffersTable from '@/components/offers/OffersTable'
import offersApi from '@/api/offers-api'
export default {
  name: 'Offers',
  components: {OffersTable},
  data() {
    return {
      filterMod: 'Default',
      freetext: '',
      offers: [],
      page: 1,
      pageSize: 16,
      total: 0,
      sortOrder: 'asc',
      sortField: 'onlineTo',
    }
  },
  computed: {
    filterOnline: function() {
      return this.filterMod == 'Default' || this.filterMod == 'Online'
    },
    filterOffline: function() {
      return this.filterMod == 'Default' || this.filterMod == 'Offline'
    },
  },
  async mounted() {
    await this.refreshData()
  },
  methods: {
    async refreshData() {
      const result = await offersApi.getOfferTemplates(
        this.page,
        this.pageSize,
        `${this.sortField} ${this.sortOrder}`,
        {
          fulltextSearch: this.freetext,
          online: this.filterOnline,
          offline: this.filterOffline,
        },
      )
      this.offers = result.results
      this.page = result.page
      this.pageSize = result.pageSize
      this.total = result.total
    },
    async pageChange(page) {
      this.page = page
      await this.refreshData()
    },
    async pageSort(...args) {
      let [field, order] = args
      this.sortField = field
      this.sortOrder = order
      await this.refreshData()
    },
    async search() {
      this.page = 1
      await this.refreshData()
    },
  },
}
</script>
